import { useAppDispatch, useAppSelector } from "./hooks";
import { store } from "./configureStore";

export { useAppDispatch as useDispatch, useAppSelector as useSelector };
export { store };
